import classNames from 'classnames';

import { Skeleton } from '@ui/Skeleton';

import s from './ProductSizeSelect.sss';

interface Props {
  className?: string,
  count?: number,
}

export const ProductSizeSelectSkeleton: React.FC<Props> = ({
  className,
  count = 3,
}) => (
  <ul className={classNames(s.list, className)}>
    {Array(count).fill(null).map((_, i) => (
      <li
        key={i}
        className={s.item}
      >
        <Skeleton
          width="35px"
          height="35px"
        />
      </li>
    ))}
  </ul>
);
